import { FC } from 'react'
import Typography from '@/ui/components/typography'
import { IssueStatusProps } from './IssueStatus.types'
import { StyledIssueStatus } from './IssueStatus.styles'
import { useCustomTheme } from '@/core/theme'

const IssueStatus: FC<IssueStatusProps> = ({
    count,
    description,
    className,
    testId,
}) => {
    const theme = useCustomTheme()

    return (
        <StyledIssueStatus className={className} data-testid={testId}>
            <Typography variant="xl-regular" color={theme.colors.greys[900]}>
                {count}
            </Typography>
            <Typography variant="s-regular" color={theme.colors.greys[500]}>
                {description}
            </Typography>
        </StyledIssueStatus>
    )
}

export default IssueStatus
